module.exports = "../images/system.png?5733602de1a0daa0a2814214eb86f33e";